var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "tree-item-wrapper" },
    [
      _c(
        "div",
        {
          staticClass: "tree-item d-flex align-items-center px-3 py-1",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _setup.handleTreeItem()
            },
          },
        },
        [
          _c(_setup.CCheckbox, { attrs: { value: _setup.selected } }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex flex-grow-1 w40",
              class: { "level-1": _setup.hasChildren ? true : false },
            },
            [
              _c("span", { staticClass: "ml-2" }, [
                _vm._v(_vm._s(_vm.treeItem.name)),
              ]),
            ]
          ),
          _vm._v(" "),
          !_setup.hasChildren
            ? _c(_setup.CDropdown, {
                staticClass: "w-50",
                attrs: {
                  options: _setup.getElementTypes(_vm.treeItem.type),
                  value: _vm.treeItem.type,
                  name: "treeType",
                  placeholder: "Select Element Type",
                },
                on: {
                  input: function ($event) {
                    return _setup.onTreeItemTypeChange(_vm.treeItem, $event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.treeItem.paginatedChildren, function (item, index) {
        return _c("modal-import-layers-tree-item-external", {
          key: `tree-item-${index}`,
          attrs: { "tree-item": item, "tree-item-index": index },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }